import { useTranslation } from 'next-i18next';
import React, { useCallback, useMemo } from 'react';
import { StyledFilterBy } from 'src/features/white-labels/techcontemporary/explore/containers/explore-filter-container/styles';
import { useScreenDetect } from 'src/hooks/useScreenDetect';
import { FilterPriceRange } from '../../components/explore-art-filter-items/filter-price-range';
import { useFilters, useSetFilters } from '../../hooks/use-explore-arts';
import { ArtistFilterContainer } from '../entity-filter-container/artist-filter-container';
import { TypesFilterContainer } from '../entity-filter-container/types-filter-container';
import { FilterItem } from './filter-item';

export const TechExploreFilterContainer = () => {
    const screen = useScreenDetect();
    const { t } = useTranslation(['components']);
    const locale = useMemo(
        () => ({
            filterBy: t('explore.filters.filterBy', { ns: 'tech-contemporary' }),
        }),
        [t]
    );
    const filters = useFilters();
    const setFilters = useSetFilters();

    const handleFiltersChange = useCallback(
        (type: any, value: any) => {
            if (type === 'priceRange') {
                const centPrice = {
                    from: value.from ? String(value.from * 100) : value.from,
                    to: value.to ? String(value.to * 100) : value.to,
                };
                setFilters({
                    ...filters,
                    [type]: centPrice,
                });
            } else {
                setFilters({
                    ...filters,
                    [type]: value,
                });
            }
        },
        [filters, setFilters]
    );

    return (
        <>
            {!screen.xs && (
                <StyledFilterBy variant="text" color="gs100" size="sm">
                    {locale.filterBy}
                </StyledFilterBy>
            )}
            <FilterItem
                title={t('explore.filters.artist', { ns: 'tech-contemporary' })}
                isActive={!!filters.artistIds?.length}
            >
                <ArtistFilterContainer
                    // @ts-ignore
                    selected={filters.artistId}
                    onChange={() => null}
                />
            </FilterItem>
            <FilterItem
                title={t('explore.filters.artType', { ns: 'tech-contemporary' })}
                isActive={!!filters.isPhysical?.length}
            >
                <TypesFilterContainer
                    // @ts-ignore
                    selected={filters.isPhysical}
                    onChange={handleFiltersChange}
                />
            </FilterItem>
            <FilterItem
                title={t('explore.filters.priceRange', { ns: 'tech-contemporary' })}
                isActive={!!filters.priceRange?.from || !!filters.priceRange?.to}
            >
                <FilterPriceRange values={filters.priceRange!} onChange={handleFiltersChange} />
            </FilterItem>
        </>
    );
};